var _path, _path2, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarningIconYellow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 34 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#d68c49",
    strokeWidth: 2,
    d: "m17.88 3.8 13.68 25.73a1 1 0 0 1-.89 1.47H3.33a1 1 0 0 1-.89-1.47L16.12 3.8a1 1 0 0 1 1.76 0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#d68c49",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M17 12.6v7.93"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 24.5,
    r: 1.7,
    fill: "#d68c49"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningIconYellow);
export default __webpack_public_path__ + "static/media/warning-icon-yellow.673fc69347b68a240a8665af77582af6.svg";
export { ForwardRef as ReactComponent };